var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.73,
    height: 100.72,
    viewBox: "0 0 100.73 100.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "no-content") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 79.94 65.06 42.45 80.45 51.29 100.73 62.83 35.64 100.72 0 79.94",
    fill: "#010101",
    fillRule: "evenodd",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.72,57.71a3,3,0,0,1-.59-1.37,1.08,1.08,0,0,1,.37-1.12l-3.38,1.94a0.9,0.9,0,0,0-.39.69,2.57,2.57,0,0,0,.2,1.16,1.81,1.81,0,0,0,.44.65A31.56,31.56,0,0,0,52.72,57.71Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.37 59.66 49.18 59.88 52.53 57.93 52.72 57.71 49.37 59.66",
    fill: "#3b3836",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52,56.87a1.89,1.89,0,0,1,.86,1.48,0.53,0.53,0,0,1-.87.49,1.89,1.89,0,0,1-.86-1.48A0.53,0.53,0,0,1,52,56.87Z",
    fill: "#4d4947",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.18,55.88l1.15-.67a1.42,1.42,0,0,1,1.55.48,3.32,3.32,0,0,1,.7,1,2.89,2.89,0,0,1,.31,1.23,1.31,1.31,0,0,1-.18.71,0.76,0.76,0,0,1-.26.25l-1.15.67a3.59,3.59,0,0,0-.24-2.4A3.22,3.22,0,0,0,51.18,55.88Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.83,56.85h0l-0.13,0H51.51l-0.11,0h0l-0.08.07h0a0.48,0.48,0,0,0-.07.1v0a0.68,0.68,0,0,0,0,.13v0a0.89,0.89,0,0,0,0,.16,1.22,1.22,0,0,0,0,.17v0.05l0,0.13,0,0.07,0,0.09L51.31,58l0.06,0.12,0,0.05,0.11,0.17v0l0.11,0.13,0,0,0.1,0.1,0,0L52,58.81l0.17,0.08H52.2l0.1,0h0.16l0.07,0,0.07,0,0,0,0,0,0-.07,0,0a0.63,0.63,0,0,0,0-.12h0a0.9,0.9,0,0,0,0-.18,1.24,1.24,0,0,0,0-.19v0a1.6,1.6,0,0,0,0-.18v0a1.82,1.82,0,0,0-.07-0.18h0l-0.08-.17,0,0-0.11-.16-0.06-.07-0.08-.09-0.11-.1L52.15,57,52,56.92l-0.15-.07h0Zm-1.08,0h0c0-.06,0-0.12,0-0.18V56.59l0-.11V56.42l0-.09V56.28l0-.08,0,0v0l0-.07,0,0h0L51.06,56l0,0h0l0.11-.07h0l0.1,0h0l0.13,0h0.27l0.1,0,0.06,0,0.11,0h0L52.25,56l0.16,0.1,0.05,0,0.1,0.08,0.06,0.05,0.09,0.08,0.06,0.06,0.08,0.09,0,0,0,0,0.21,0.26h0l0,0L53.25,57l0,0v0l0.1,0.17v0h0l0.09,0.2h0l0,0.05,0.05,0.14v0l0,0.06,0,0.12V58l0,0.11v0.09l0,0.11v0.19s0,0,0,0,0,0,0,.07,0,0.09,0,.13v0a1.53,1.53,0,0,1,0,.15v0h0a1.23,1.23,0,0,1,0,.17v0l-0.06.13v0h0a0.81,0.81,0,0,1-.12.15h0l0,0-0.06,0,0,0-0.07,0,0,0h0l-0.16,0H52.68l-0.09,0-0.06,0-0.1,0-0.05,0-0.15-.08L52,59.29l0,0-0.19-.16h0L51.6,58.9l0,0-0.17-.21h0v0l-0.15-.23,0,0-0.14-.25v0L51,58l0-.11,0-.08,0-.11,0,0v0c0-.09-0.06-0.19-0.08-0.28V57.31c0-.07,0-0.13,0-0.2V57.06c0-.07,0-0.14,0-0.21h0Z",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.11,58A1.89,1.89,0,0,1,51,59.48a0.53,0.53,0,0,1-.87.49,1.89,1.89,0,0,1-.86-1.48A0.53,0.53,0,0,1,50.11,58Z",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.31,57l1.15-.67a1.42,1.42,0,0,1,1.55.48,3.32,3.32,0,0,1,.7,1A2.89,2.89,0,0,1,53,59a1.3,1.3,0,0,1-.18.71,0.76,0.76,0,0,1-.26.25l-1.15.67a3.59,3.59,0,0,0-.24-2.4A3.22,3.22,0,0,0,49.31,57Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,58h0l-0.13,0H49.63l-0.11,0h0l-0.09.07h0a0.47,0.47,0,0,0-.07.1v0a0.66,0.66,0,0,0,0,.13v0a0.9,0.9,0,0,0,0,.16,1.25,1.25,0,0,0,0,.17v0.05l0,0.13,0,0.07,0,0.09,0.05,0.13,0.06,0.12,0,0.05,0.11,0.17v0l0.11,0.13,0,0,0.1,0.1,0,0,0.15,0.1L50.27,60h0.05l0.1,0h0.16l0.07,0,0.07,0,0,0,0,0,0-.07,0,0a0.62,0.62,0,0,0,0-.12h0a0.92,0.92,0,0,0,0-.18,1.21,1.21,0,0,0,0-.19v0a1.63,1.63,0,0,0,0-.18v0a1.8,1.8,0,0,0-.07-0.18h0l-0.08-.17,0,0-0.11-.16-0.06-.07-0.08-.09-0.11-.1-0.05-.05L50.11,58,50,58h0Zm-1.08,0h0c0-.06,0-0.12,0-0.18V57.71s0-.07,0-0.11V57.54l0-.09V57.4l0-.08,0,0v0l0-.07,0,0h0l0.07-.07,0,0h0L49.32,57h0l0.1,0h0l0.13,0h0.27l0.1,0L50,57l0.11,0,0,0h0l0.16,0.08,0.16,0.1,0.05,0,0.1,0.08,0.06,0.05,0.09,0.08,0.06,0.06L51,57.61l0,0,0,0,0.21,0.26h0l0,0,0.11,0.17,0,0v0l0.1,0.17v0h0l0.09,0.2h0l0,0.05,0.05,0.14v0l0,0.06,0,0.12v0.08l0,0.11v0.09l0,0.11v0.08s0,0.07,0,.11v0s0,0,0,.07,0,0.09,0,.13v0a1.5,1.5,0,0,1,0,.15v0h0a1.22,1.22,0,0,1,0,.17v0l-0.06.13v0h0a0.82,0.82,0,0,1-.12.15h0l0,0-0.06,0,0,0-0.07,0,0,0h0l-0.16,0H50.81l-0.09,0-0.06,0-0.1,0-0.05,0-0.15-.08-0.21-.14,0,0-0.19-.16h0L49.73,60l0,0-0.17-.21h0l-0.15-.23,0,0-0.14-.25v0l0-.05,0-.11,0-.08,0-.11,0,0v0c0-.09-0.06-0.19-0.08-0.28V58.43c0-.07,0-0.13,0-0.2V58.18c0-.07,0-0.14,0-0.21h0Z",
    fill: "#141313",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50.09,56.86l3.35-1.95a1.21,1.21,0,0,0-1.18-.12h0L48.9,56.75A2,2,0,0,1,50.09,56.86Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.35,58.26l3.35-1.95a3.78,3.78,0,0,0-.9-1.14h0a2.46,2.46,0,0,0-.35-0.25l-3.35,1.95A5.37,5.37,0,0,1,51.35,58.26Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.09,56.86a1,1,0,0,0-1.67,1,3.57,3.57,0,0,0,.77,2.06l0.11-.1,0.08-.12A2.84,2.84,0,0,1,48.75,58a0.81,0.81,0,0,1,1.33-.76,2.76,2.76,0,0,1,1,1.11l0.26-.1A3.48,3.48,0,0,0,50.09,56.86Z",
    fill: "#010101",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,57.71a1.89,1.89,0,0,0-.86,1.48,0.53,0.53,0,0,0,.87.49,1.89,1.89,0,0,0,.86-1.48A0.53,0.53,0,0,0,19,57.71Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.82,56.72l-1.15-.67a1.42,1.42,0,0,0-1.55.48,3.32,3.32,0,0,0-.7,1,2.89,2.89,0,0,0-.31,1.23,1.3,1.3,0,0,0,.18.71,0.76,0.76,0,0,0,.26.25l1.15,0.67a3.59,3.59,0,0,1,.24-2.4A3.22,3.22,0,0,1,19.82,56.72Z",
    fill: "#4e4a49",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.17,57.68h0l0.13,0h0.17l0.11,0h0l0.09,0.07h0a0.47,0.47,0,0,1,.07.1v0a0.68,0.68,0,0,1,0,.13v0a0.9,0.9,0,0,1,0,.16,1.25,1.25,0,0,1,0,.17v0.05l0,0.13,0,0.07,0,0.09-0.05.13L19.63,59l0,0.05-0.11.17v0l-0.11.13,0,0-0.1.09,0,0-0.15.1-0.17.08H18.81l-0.1,0H18.54l-0.07,0-0.07,0,0,0,0,0,0-.07,0,0a0.64,0.64,0,0,1,0-.12h0a0.92,0.92,0,0,1,0-.18,1.22,1.22,0,0,1,0-.19v0a1.6,1.6,0,0,1,0-.18v0a1.75,1.75,0,0,1,.07-0.18h0l0.08-.17,0,0,0.11-.16,0.06-.07L18.69,58l0.11-.1,0.05-.05L19,57.75l0.15-.07h0Zm1.08,0h0a1.77,1.77,0,0,0,0-.18V57.43s0-.07,0-0.11V57.26l0-.09V57.11l0-.08,0,0v0l0-.07,0,0h0l-0.07-.07,0,0h0l-0.11-.07h0l-0.1,0h0l-0.13,0H19.23l-0.1,0-0.06,0-0.11,0,0,0h0l-0.16.08-0.16.1-0.05,0-0.1.08-0.06.05-0.09.08-0.06.06-0.08.09,0,0,0,0-0.21.26h0l0,0-0.11.17,0,0v0l-0.1.17v0h0l-0.09.2h0l0,0.05-0.05.14v0l0,0.06,0,0.12v0.08l0,0.11V59l0,0.11v0.08s0,0.07,0,.11,0,0,0,0,0,0,0,.07,0,0.09,0,.13v0a1.52,1.52,0,0,0,0,.15v0h0a1.22,1.22,0,0,0,0,.17v0l0.06,0.13v0h0a0.79,0.79,0,0,0,.12.15h0l0,0,0.06,0,0,0,0.07,0,0,0h0l0.16,0h0.36l0.09,0,0.06,0,0.1,0,0.05,0,0.15-.08L19,60.13l0,0,0.19-.16h0l0.17-.18,0,0,0.17-.21h0v0l0.15-.23,0,0,0.14-.25v0l0-.05,0-.11,0-.08,0-.11,0,0v0c0-.09.06-0.19,0.08-0.28V58.15c0-.07,0-0.13,0-0.2V57.89c0-.07,0-0.14,0-0.21h0Z",
    fill: "#2b2926",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,56.44l-3.35-1.95h0a1.12,1.12,0,0,0-1,0,3,3,0,0,0-1.05.91l0,0.06a4,4,0,0,0-.43.75,3.17,3.17,0,0,0-.28,1.23,1.17,1.17,0,0,0,.48,1.07l3.35,1.95a1.46,1.46,0,0,1-.42-1.09,4,4,0,0,1,1.31-2.61l0,0A1.74,1.74,0,0,1,20,56.44Z",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,56.55a3.67,3.67,0,0,0-1.66,2.88,1,1,0,0,0,.78,1.17l0.18-.43a0.82,0.82,0,0,1-.62-0.93,2.92,2.92,0,0,1,1.32-2.29,0.9,0.9,0,0,1,1,0l0.25-.4A1.14,1.14,0,0,0,18.8,56.55Z",
    fill: "#191817",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52,75.37a1.89,1.89,0,0,0-.86,1.48,0.53,0.53,0,0,0,.87.49,1.89,1.89,0,0,0,.86-1.48A0.53,0.53,0,0,0,52,75.37Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.81,74.38l-1.15-.67a1.42,1.42,0,0,0-1.55.48,3.32,3.32,0,0,0-.7,1,2.89,2.89,0,0,0-.31,1.23,1.3,1.3,0,0,0,.18.71,0.76,0.76,0,0,0,.26.25L50.69,78a3.59,3.59,0,0,1,.24-2.4A3.22,3.22,0,0,1,52.81,74.38Z",
    fill: "#4e4a49",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.16,75.34h0l0.13,0h0.17l0.11,0h0l0.09,0.07h0a0.47,0.47,0,0,1,.07.1v0a0.68,0.68,0,0,1,0,.13v0a0.9,0.9,0,0,1,0,.16,1.25,1.25,0,0,1,0,.17v0.05l0,0.13,0,0.07,0,0.09-0.05.13-0.06.12,0,0.05-0.11.17v0L52.35,77l0,0-0.1.09,0,0L52,77.3l-0.17.08H51.79l-0.1,0H51.53l-0.07,0-0.07,0,0,0,0,0,0-.07,0,0a0.63,0.63,0,0,1,0-.12h0a0.92,0.92,0,0,1,0-.18,1.21,1.21,0,0,1,0-.19v0a1.61,1.61,0,0,1,0-.18v0a1.75,1.75,0,0,1,.07-0.18h0L51.42,76l0,0,0.11-.16,0.06-.07,0.08-.09,0.11-.1,0.05-.05L52,75.41l0.15-.07h0Zm1.08,0h0c0-.06,0-0.12,0-0.18V75.09s0-.07,0-0.11V74.92l0-.09V74.78l0-.08,0,0v0l0-.07,0,0h0l-0.07-.07,0,0h0l-0.11-.07h0l-0.1,0h0l-0.13,0H52.22l-0.1,0-0.06,0-0.11,0h0l-0.16.08-0.16.1-0.05,0-0.1.08-0.06.05-0.09.08-0.06.06L51.13,75l0,0,0,0-0.21.26h0l0,0-0.11.17,0,0v0l-0.1.17v0h0L50.5,76h0l0,0.05-0.05.14v0l0,0.06,0,0.12v0.08l0,0.11v0.09l0,0.11v0.08s0,0.07,0,.11,0,0,0,0,0,0,0,.07,0,0.09,0,.13v0a1.47,1.47,0,0,0,0,.15v0h0a1.22,1.22,0,0,0,0,.17v0l0.06,0.13v0h0a0.8,0.8,0,0,0,.12.15h0l0,0,0.06,0,0,0,0.07,0,0,0h0l0.16,0h0.36l0.09,0,0.06,0,0.1,0,0.05,0,0.15-.08L52,77.79l0,0,0.19-.16h0l0.17-.18,0,0,0.17-.21h0l0.15-.23,0,0,0.14-.25v0l0-.05,0-.11,0-.08,0-.11,0,0v0c0-.09.06-0.19,0.08-0.28V75.81c0-.07,0-0.13,0-0.2V75.55a2.12,2.12,0,0,0,0-.21h0Z",
    fill: "#2b2926",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53,74.1l-3.35-1.95h0a1.12,1.12,0,0,0-1,0,3,3,0,0,0-1.05.91l0,0.06a4,4,0,0,0-.43.75,3.17,3.17,0,0,0-.28,1.23,1.17,1.17,0,0,0,.48,1.07l3.35,1.95a1.46,1.46,0,0,1-.42-1.09,4,4,0,0,1,1.31-2.61l0,0A1.74,1.74,0,0,1,53,74.1Z",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.78,74.21a3.67,3.67,0,0,0-1.66,2.88,1,1,0,0,0,.78,1.17l0.18-.43a0.82,0.82,0,0,1-.62-0.93,2.92,2.92,0,0,1,1.32-2.29,0.9,0.9,0,0,1,1,0l0.25-.4A1.14,1.14,0,0,0,51.78,74.21Z",
    fill: "#191817",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.18,75.75a3,3,0,0,1-.59-1.37A1.08,1.08,0,0,1,19,73.26L15.58,75.2a0.9,0.9,0,0,0-.39.69,2.57,2.57,0,0,0,.2,1.16,1.8,1.8,0,0,0,.44.65A31.54,31.54,0,0,0,19.18,75.75Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.83 77.7 15.65 77.92 19 75.98 19.18 75.75 15.83 77.7",
    fill: "#3b3836",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.45,74.92a1.89,1.89,0,0,1,.86,1.48,0.53,0.53,0,0,1-.87.49,1.89,1.89,0,0,1-.86-1.48A0.53,0.53,0,0,1,18.45,74.92Z",
    fill: "#4d4947",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.65,73.93l1.15-.67a1.42,1.42,0,0,1,1.55.48,3.32,3.32,0,0,1,.7,1A2.9,2.9,0,0,1,21.35,76a1.31,1.31,0,0,1-.18.71,0.76,0.76,0,0,1-.26.25l-1.15.67a3.59,3.59,0,0,0-.24-2.4A3.22,3.22,0,0,0,17.65,73.93Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29,74.89h0l-0.13,0H18l-0.11,0h0L17.77,75h0l-0.07.1v0a0.67,0.67,0,0,0,0,.13v0a0.9,0.9,0,0,0,0,.16,1.25,1.25,0,0,0,0,.17v0.05l0,0.13,0,0.07,0,0.09,0.05,0.13,0.06,0.12,0,0.05L18,76.42v0l0.11,0.13,0,0,0.1,0.1,0,0,0.15,0.1,0.17,0.08h0.05l0.1,0h0.16l0.07,0,0.07,0,0,0,0,0,0-.07,0,0a0.62,0.62,0,0,0,0-.12h0a0.91,0.91,0,0,0,0-.18,1.24,1.24,0,0,0,0-.19v0a1.61,1.61,0,0,0,0-.18v0a1.81,1.81,0,0,0-.07-0.18h0L19,75.6l0,0-0.11-.16-0.06-.07-0.08-.09-0.11-.1-0.05-.05L18.45,75l-0.15-.07h0Zm-1.08,0h0c0-.06,0-0.12,0-0.18V74.64l0-.11V74.47l0-.09V74.32l0-.08,0,0v0l0-.07,0,0h0L17.53,74l0,0h0l0.11-.07h0l0.1,0h0l0.13,0h0.27l0.1,0,0.06,0,0.11,0,0,0h0L18.71,74l0.16,0.1,0.05,0L19,74.26l0.06,0.05,0.09,0.08,0.06,0.06,0.08,0.09,0,0,0,0,0.21,0.26h0l0,0,0.11,0.17,0,0v0l0.1,0.17v0h0L20,75.52h0l0,0.05L20,75.72v0l0,0.06,0,0.12V76l0,0.11V76.2l0,0.11v0.25s0,0,0,.07,0,0.09,0,.13v0a1.48,1.48,0,0,1,0,.15v0h0a1.22,1.22,0,0,1,0,.17v0L20,77.29v0h0a0.81,0.81,0,0,1-.12.15h0l0,0-0.06,0,0,0-0.07,0,0,0h0l-0.16,0H19.15l-0.09,0-0.06,0-0.1,0-0.05,0-0.15-.08-0.21-.14,0,0-0.19-.16h0l-0.17-.18,0,0-0.17-.21h0l-0.15-.23,0,0-0.14-.25v0l0-.05,0-.11,0-.08,0-.11,0,0v0c0-.09-0.06-0.19-0.08-0.28V75.36q0-.1,0-0.2V75.1c0-.07,0-0.14,0-0.21h0Z",
    fill: "#0f0f0f",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.57,76a1.89,1.89,0,0,1,.86,1.48,0.53,0.53,0,0,1-.87.49,1.89,1.89,0,0,1-.86-1.48A0.53,0.53,0,0,1,16.57,76Z",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.77,75.05l1.15-.67a1.42,1.42,0,0,1,1.55.48,3.32,3.32,0,0,1,.7,1,2.89,2.89,0,0,1,.31,1.23,1.3,1.3,0,0,1-.18.71A0.76,0.76,0,0,1,19,78l-1.15.67a3.59,3.59,0,0,0-.24-2.4A3.22,3.22,0,0,0,15.77,75.05Z",
    fill: "#3c3937",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.42,76h0l-0.13,0H16.1L16,76h0l-0.09.07h0a0.47,0.47,0,0,0-.07.1v0a0.67,0.67,0,0,0,0,.13v0a0.89,0.89,0,0,0,0,.16,1.25,1.25,0,0,0,0,.17v0.05l0,0.13,0,0.07,0,0.09L15.9,77.2,16,77.32l0,0.05,0.11,0.17v0l0.11,0.13,0,0,0.1,0.09,0,0L16.57,78l0.17,0.08h0.05l0.1,0h0.16l0.07,0,0.07,0,0,0,0,0,0-.07,0,0a0.62,0.62,0,0,0,0-.12h0a0.92,0.92,0,0,0,0-.18,1.22,1.22,0,0,0,0-.19v0a1.61,1.61,0,0,0,0-.18v0a1.76,1.76,0,0,0-.07-0.18h0l-0.08-.17,0,0L17,76.53,17,76.45l-0.08-.09-0.11-.1-0.05-.05-0.17-.12L16.42,76h0Zm-1.08,0h0c0-.06,0-0.12,0-0.18V75.76s0-.07,0-0.11V75.59l0-.09V75.45l0-.08,0,0v0l0-.07,0,0h0l0.07-.07,0,0h0L15.79,75h0l0.1,0h0l0.13,0h0.27l0.1,0,0.06,0,0.11,0,0,0h0l0.16,0.08L17,75.26l0.05,0,0.1,0.08,0.06,0.05,0.09,0.08,0.06,0.06,0.08,0.09,0,0,0,0L17.7,76h0l0,0,0.11,0.17,0,0v0L18,76.41v0h0l0.09,0.2h0l0,0.05,0.05,0.14v0l0,0.06,0,0.12v0.08l0,0.11v0.09l0,0.11v0.08s0,0.07,0,.11v0s0,0,0,.07,0,0.09,0,.13v0a1.47,1.47,0,0,1,0,.15v0h0a1.24,1.24,0,0,1,0,.17v0l-0.06.13v0h0a0.8,0.8,0,0,1-.12.15h0l0,0-0.06,0,0,0-0.07,0,0,0h0l-0.16,0H17.27l-0.09,0-0.06,0-0.1,0-0.05,0-0.15-.08-0.21-.14,0,0-0.19-.16h0l-0.17-.18,0,0L16,77.81h0v0l-0.15-.23,0,0-0.14-.25v0l0-.05,0-.11,0-.08,0-.11,0,0v0c0-.09-0.06-0.19-0.08-0.28V76.48c0-.07,0-0.13,0-0.2V76.22a2.12,2.12,0,0,1,0-.21h0Z",
    fill: "#141313",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.55,74.91L19.9,73a1.2,1.2,0,0,0-1.18-.12h0l-3.35,1.95A2,2,0,0,1,16.55,74.91Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.81,76.31l3.35-1.95a3.77,3.77,0,0,0-.9-1.14h0A2.45,2.45,0,0,0,19.9,73l-3.35,1.95A5.36,5.36,0,0,1,17.81,76.31Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55,74.91a1,1,0,0,0-1.67,1,3.57,3.57,0,0,0,.77,2.06l0.11-.1,0.08-.12a2.84,2.84,0,0,1-.61-1.64,0.81,0.81,0,0,1,1.33-.76,2.76,2.76,0,0,1,1,1.11l0.26-.1A3.48,3.48,0,0,0,16.55,74.91Z",
    fill: "#010101",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "30.91 62.55 32.48 61.54 34.26 60.6 34.25 62.8 30.9 64.75 30.77 62.96 30.91 62.55",
    fill: "#141313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.92,53.84l13.67,7.75,1.32,1v2.2l-15-8.67a2,2,0,0,1-1.11-1.75C14.77,53.72,15.12,53.38,15.92,53.84Z",
    fill: "#141313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,53.7h0l3.35-1.95h0a1,1,0,0,1,.87.17l-2.77,1.72-0.58.23A1,1,0,0,0,15,53.7Z",
    fill: "#141313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.24 51.92 34.26 60.6 30.91 62.55 15.88 53.87 19.24 51.92",
    fill: "#211f1e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "37.59 62.55 36.01 61.55 34.23 60.6 34.24 62.8 37.59 64.75 37.72 62.96 37.59 62.55",
    fill: "#3b3a38",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.57,53.85L38.9,61.59l-1.32,1v2.2l15-8.67a2,2,0,0,0,1.11-1.75C53.72,53.73,53.37,53.39,52.57,53.85Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.48,53.71h0l-3.35-1.95h0a1,1,0,0,0-.86.17L52,53.65l0.58,0.23A1,1,0,0,1,53.48,53.71Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.26 51.93 34.23 60.6 37.59 62.55 52.61 53.88 49.26 51.93",
    fill: "#211f1e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.2,73.14l14.19-8.68,1.51,0-0.65,2.2-15,8.67c-0.8.46-1.15,0.15-1.16-.47A2.05,2.05,0,0,1,19.2,73.14Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,72.15a2.27,2.27,0,0,1,.92-0.93l1.68,0.9,1.67,1a2,2,0,0,0-1.11,1.73,0.86,0.86,0,0,0,.15.55,0.38,0.38,0,0,0,.1.09L15,73.58A0.68,0.68,0,0,1,14.77,73,1.78,1.78,0,0,1,15,72.15Z",
    fill: "#141313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.9 62.54 34.25 64.49 19.23 73.16 15.88 71.22 30.9 62.54",
    fill: "#211f1e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.54,72.15a2.27,2.27,0,0,0-.92-0.93l-1.68.9-1.67,1a2,2,0,0,1,1.11,1.73,0.86,0.86,0,0,1-.15.55,0.38,0.38,0,0,1-.1.09l3.35-1.95A0.68,0.68,0,0,0,53.73,73,1.78,1.78,0,0,0,53.54,72.15Z",
    fill: "#262423",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.29,73.14L35.71,64.86l-1.46-.37v2.2l15,8.67c0.8,0.46,1.15.15,1.16-.47A2.05,2.05,0,0,0,49.29,73.14Z",
    fill: "#141313",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.6 62.54 34.25 64.49 49.27 73.16 52.62 71.22 37.6 62.54",
    fill: "#211f1e",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37.63,53.17A41,41,0,0,1,31,53.05l0,9.69a1.67,1.67,0,0,0,1,1.37,5.06,5.06,0,0,0,2.92.54h0c0.94-.11,2.6-0.6,2.72-1.79,0,0,0,0,0-.07v0l0-9.69S37.64,53.14,37.63,53.17Z",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.93,56.77a3.64,3.64,0,0,1-2.56,2c-1.45.25-4.37-.38-4.7-2l0,5.82a1.82,1.82,0,0,0,1.07,1.5,5.66,5.66,0,0,0,5.18,0,2,2,0,0,0,1-1.22,1.47,1.47,0,0,0,0-.22Z",
    fill: "#010101",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.51,58.59c-1.15,0-3.36-.46-3.53-1.72h0s0-.1,0-0.15V55.93c-0.57.77-.31,1.7,0.78,2.32a5.36,5.36,0,0,0,2.8.63,5.1,5.1,0,0,0,2.33-.62c1.08-.63,1.33-1.55.75-2.32v0.6a2.2,2.2,0,0,1,0,.31C37.44,58,35.63,58.56,34.51,58.59Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.66,51.7a5.19,5.19,0,0,0-4.71,0c-1.3.75-1.29,2,0,2.73a5.18,5.18,0,0,0,4.71,0C38,53.67,38,52.45,36.66,51.7Z",
    fill: "#211f1e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41.42,28.41A21.78,21.78,0,0,0,35.17,23a17.72,17.72,0,0,0-7-2.35l0.18,0.61A18.75,18.75,0,0,1,35,23.68,21.33,21.33,0,0,1,41,28.93c3.33,4.2,5.33,9.8,5.93,16.64l0.47,0.21C46.83,38.75,44.88,32.78,41.42,28.41Z",
    fill: "#555250",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.11,33.08l0,0.09a35.93,35.93,0,0,1,3.29,12.61l0.83-.48a36.77,36.77,0,0,0-2.89-11.76l-0.18-.4a23.25,23.25,0,0,0-9.4-10.49,21.17,21.17,0,0,0-5-2.09A12.14,12.14,0,0,0,29,20.18l-0.83.48h0A13,13,0,0,1,29.8,21l0.86,0.25a21.49,21.49,0,0,1,4.53,2,22.19,22.19,0,0,1,4.4,3.44l0.11,0.11A24.6,24.6,0,0,1,44.11,33.08Z",
    fill: "#cdcccc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.79,23c-0.19-.11-0.51-0.18-0.7-0.28l0,0.84,0.54,0.3C38.25,26,42.8,30.06,45.15,38L45.81,38A22.34,22.34,0,0,0,34.79,23Z",
    fill: "#583914",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.89,26.24a23.75,23.75,0,0,1,3.7,4.55A29.27,29.27,0,0,1,45.81,38l1.42-.83a28.44,28.44,0,0,0-4-8.32,23.9,23.9,0,0,0-3-3.45A22.21,22.21,0,0,0,35.56,22l0,0-1.42.83A22.22,22.22,0,0,1,38.89,26.24Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M16.57,3.79l5.95-3.46A1.79,1.79,0,0,0,20.77.16h0L14.82,3.62A1.79,1.79,0,0,1,16.57,3.79Z",
    fill: "#b4782a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89,7.14c-0.95.64-.94,2.08-0.68,3.17l1.42-.63a2.44,2.44,0,0,1,.34-2,1.39,1.39,0,0,1,1.62-.31C8.75,7.08,7.75,6.57,6.89,7.14Z",
    fill: "#583914",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08,11L10,7.59a1.79,1.79,0,0,0-1.75-.17h0L2.33,10.88A1.79,1.79,0,0,1,4.08,11Z",
    fill: "#b4782a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.44,9.39h0c-0.31-.84-0.63-1.68-1-2.52a11.15,11.15,0,0,0-1.05-2.31,6.16,6.16,0,0,0-2-2l0,0L9.2,7.3a6.26,6.26,0,0,1,2.05,2.07,11.2,11.2,0,0,1,1,2.26c0.31,0.83.64,1.66,0.94,2.5v0h0l3.44-2,4.77-2.77h0Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,12.64a26.33,26.33,0,0,1-1-2.54,5.93,5.93,0,0,0-.7-1.24A4.73,4.73,0,0,0,10,7.59h0l-3.46,2L4.08,11h0a5.25,5.25,0,0,1,2,2.24,27.49,27.49,0,0,0,1.15,2.85Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6,40.4c-0.33-2.05-.71-4.1-1.17-6.13C19.92,32,19.32,29.8,18.62,27.6c-1.34-4.18-3-8.28-4.56-12.37L13.2,13c-0.09-.24-0.15-0.39.13-0.55l-1.8,1L7.38,15.92h0c-0.27.16-.22,0.3-0.13,0.54h0c1.41,3.69,2.89,7.36,4.22,11.07A85.13,85.13,0,0,1,14.76,39c0.77,3.67,1.31,7.39,1.76,11.1l0,0.22c0.11,0.9.44,2.34-.39,3L16,53.49h0L21.93,50l0.16-.12,0,0C23.39,48.74,21.83,41.83,21.6,40.4Z",
    fill: "#a26327",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.62,5.55l-0.78-2A7.3,7.3,0,0,0,24,1.81,4.86,4.86,0,0,0,22.54.35h0L16.57,3.79h0a5,5,0,0,1,1.61,1.64L18.29,5.6a17.35,17.35,0,0,1,1,2.53,4.21,4.21,0,0,0,.38.81Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.62,36.74a94.06,94.06,0,0,0-3.33-15.8c-1.34-4.27-3-8.39-4.6-12.62L26,6.48l-0.28-.73a2.84,2.84,0,0,0-.12-0.41l-5.7,3.31a0.33,0.33,0,0,0-.16.48l0,0.08c1.61,4.22,2.94,7.56,4.08,10.7A88.51,88.51,0,0,1,28.2,37c0.23,1.45.45,3,.66,4.7q0.16,1.24.31,2.57v0.07s0,0.08,0,.12a1.88,1.88,0,0,1-.71,1.8l2.21-1.28h0c1.11-.64,4.19-1.65,4.41-3.31A23.44,23.44,0,0,0,34.62,36.74Z",
    fill: "#a26327",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2,7.3l8.21-4.77a2.28,2.28,0,0,0-2.23-.22L7,7.08A2.28,2.28,0,0,1,9.2,7.3Z",
    fill: "#774c1e",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24,29.21a95.51,95.51,0,0,0-3.71-11.77c-1.18-3.1-2.44-6.17-3.56-9.28h0l-8.21,4.77h0c0.44,1.19.91,2.39,1.37,3.58,1.19,3.06,2.4,6.12,3.48,9.22a83.7,83.7,0,0,1,2.63,9.14c0.49,2.18.89,4.39,1.24,6.6,0.27,1.73,1.81,8.44.3,9.72a1.49,1.49,0,0,1-.21.15l7.29-4.23c1.62-.94,1.89-1.15,1.81-3.19C30.53,40.05,28.77,31.42,28.24,29.21Z",
    fill: "#c5822a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68,7.05l-1.3.24-0.63,1c1.44-1.2,2.81-.1,4.23,2.19a22.19,22.19,0,0,1,1.52,3.58l0.73,0.09-0.46-1.22-0.5-1.3a11.2,11.2,0,0,0-1-2.26A6.26,6.26,0,0,0,9.2,7.3,3.55,3.55,0,0,0,8.68,7.05Z",
    fill: "#583914",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.41,2.53a2.28,2.28,0,0,0-2.23-.22L7,7.08A2.28,2.28,0,0,1,9.2,7.3a6.26,6.26,0,0,1,2.05,2.07,11.2,11.2,0,0,1,1,2.26c0.31,0.83.64,1.66,0.94,2.5v0h0l3.44-2,4.77-2.77h0c-0.31-.84-0.63-1.68-1-2.52a11.16,11.16,0,0,0-1.05-2.31,6.16,6.16,0,0,0-2-2Z",
    fill: "#996326",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.79,42.16l-1.09-.35-1.09-.35-1.09-.35-1.08-.34-1.08-.34-0.93-.3L45,38.72l-2.73-.87-0.43-.14-0.57-.18-6.59-2.1a0.91,0.91,0,0,0-.34,0,6.77,6.77,0,0,0-1.57.38,31.85,31.85,0,0,0-3.51,1.5c-0.8.39-1.58,0.79-2.36,1.21l-1.13.62-0.92.53h0l21.76,6.92C48.33,45.57,55.79,42.16,55.79,42.16Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45,42.63l0,0,0.14-.05,0.06,0,0.32-.1a0.63,0.63,0,0,1,.33,0s-0.47-.21-0.52-0.24a0.37,0.37,0,0,0-.19,0,4.93,4.93,0,0,0-1.25.39c-0.63.24-2.78,1.3-2.78,1.3-0.43.23-.89,0.44-1.32,0.69L50,44.67l-0.38.2-1.42.78-0.34.19c-0.42.25-.87,0.5-1.3,0.74l0.31,0.12,0,0,0.08,0,0.26,0.13c1.35-.78,2.63-1.5,3.78-2.12,1.78-1,3.26-1.69,4.21-2.08Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.13,42.3h0Z",
    fill: "#bdbbba",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.82 39.67 22.54 41 44.29 47.92 46.57 46.59 24.82 39.67",
    fill: "#a26327",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.56,45.28a6.39,6.39,0,0,0-.41-1,4.51,4.51,0,0,0-1.64-1.74,1,1,0,0,0-.16-0.1,0.87,0.87,0,0,0-.53.07c-2.56.77-6.31,3.11-8.57,4.43,1.34,0.78,2.39,3.38,2.49,5.37,0,0.87.45,1.64-.28,2.06h0c1.48-.86,2.92-1.76,4.37-2.69,0.84-.55,1.37-0.92,1.54-1h0c0.89-.63,2.79-1.9,3.22-3A3.23,3.23,0,0,0,58.56,45.28Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,48.23l2.28-1.33a3.34,3.34,0,0,0-.69-0.31l-2.28,1.33,0.34,0.13h0Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3,54.2a54.42,54.42,0,0,1,8.68-6,3.63,3.63,0,0,0-.69-0.31c-0.72.42-1.41,0.83-2.09,1.25l-1.54.94c-1.06.63-2.26,1.28-3.28,2-0.31.22-1,.78-1.55,1.24a3.56,3.56,0,0,0-.44.51,0.45,0.45,0,0,0-.06.29l0.53,0.24A1.66,1.66,0,0,1,36.3,54.2Z",
    fill: "#a26327",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.51,53.83a13.57,13.57,0,0,1,2.05-1.66c0.75-.55,1.56-1.07,2.34-1.58,1.46-.89,2.9-1.82,4.39-2.68L22.54,41a56.44,56.44,0,0,0-6,3.92c-0.43.33-.85,0.67-1.26,1a7.85,7.85,0,0,0-.65.65,2.34,2.34,0,0,0-.34.49,0.37,0.37,0,0,0,0,.37l18.62,6.95,2.42-.25A0.6,0.6,0,0,1,35.51,53.83Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,51.64a7.23,7.23,0,0,0-.94-1.82A6.76,6.76,0,0,0,45,48.23,70.83,70.83,0,0,0,36.2,54a1.14,1.14,0,0,0-.34.43c0.06,0,3.34,6.62.51,5.72a1.4,1.4,0,0,0,.4.13,1.93,1.93,0,0,0,.72,0,5.07,5.07,0,0,0,.86-0.21c0.42-.14.84-0.3,1.25-0.47,1.92-.83,3.75-1.78,5.59-2.78l1.24-.7,0.76-.44a2.72,2.72,0,0,0,1.22-2.4A6.84,6.84,0,0,0,48,51.64Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.09,50.6a7.1,7.1,0,0,0-2.8-3.68l0,0L45,48.23a6.72,6.72,0,0,1,2.48,2.84c0.51,1.23,1.19,3.32,0,4.39l0,0a1.67,1.67,0,0,1-.23.17l2.28-1.33C50.75,53.59,50.44,51.65,50.09,50.6Z",
    fill: "#e3dcdc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.17,57.87a5.34,5.34,0,0,0-2.25-3.44,5.8,5.8,0,0,0-.59-0.27l-21-6.69,0.82,5.23,21.25,7.41C37.65,60.52,38.46,59.52,38.17,57.87Z",
    fill: "#583914",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.68,51.49c-2-17.1-4.34-21.68-9.43-35a0.61,0.61,0,0,1-.07-0.34,20.3,20.3,0,0,1-1-2.4A5.87,5.87,0,0,0,5.87,13,5.08,5.08,0,0,0,4.08,11a2.16,2.16,0,0,0-1.2-.33c-1.19.08-1.61,1.56-1,3.3,0.23,0.61.4,1.05,0.5,1.35A13.31,13.31,0,0,1,3,16.76c4.77,12.45,7,16.64,8.83,32.72,0.29,2.57,3,3.24,5.1,3.82C17.15,52.93,16.76,52.15,16.68,51.49Z",
    fill: "#583914",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,40.28a21.78,21.78,0,0,0-6.25-5.4,17.71,17.71,0,0,0-7-2.35L7.9,33.14a18.75,18.75,0,0,1,6.61,2.41,21.32,21.32,0,0,1,6.07,5.25c3.33,4.2,5.33,9.8,5.93,16.64L27,57.65C26.37,50.62,24.42,44.65,21,40.28Z",
    fill: "#555250",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.65,44.95l0,0.09A35.93,35.93,0,0,1,27,57.65l0.83-.48a36.77,36.77,0,0,0-2.89-11.76L24.75,45a23.25,23.25,0,0,0-9.4-10.49,21.19,21.19,0,0,0-5-2.09A12.18,12.18,0,0,0,8.55,32l-0.83.48h0a13.09,13.09,0,0,1,1.59.33l0.86,0.25a21.5,21.5,0,0,1,4.53,2,22.18,22.18,0,0,1,4.4,3.44l0.11,0.11A24.6,24.6,0,0,1,23.65,44.95Z",
    fill: "#cdcccc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.33,34.9c-0.19-.11-0.51-0.18-0.7-0.28l0,0.84,0.54,0.3c3.6,2.08,8.15,6.17,10.49,14.06l0.66,0.07A22.34,22.34,0,0,0,14.33,34.9Z",
    fill: "#583914",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.43,38.12a23.76,23.76,0,0,1,3.7,4.55,29.27,29.27,0,0,1,3.22,7.22l1.42-.83a28.44,28.44,0,0,0-4-8.32,23.89,23.89,0,0,0-3-3.45,22.21,22.21,0,0,0-4.75-3.47l0,0-1.42.83A22.24,22.24,0,0,1,18.43,38.12Z",
    fill: "#b46d29",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M35.6,74.4l0.3,6.78L35.66,94.76l-0.12,0-0.08,0H35.15L35,94.8l-0.21-.1L34.55,81.79l0.2-7.45A0.89,0.89,0,0,0,35.6,74.4Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "34.75 74.34 34.82 94.7 8.32 79.3 8.26 58.94 34.75 74.34",
    fill: "#282828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,74.2l0.26-.15,0.26-.15A0.79,0.79,0,0,0,37,73.46l0.07,20.36a0.79,0.79,0,0,1-.48.44l-0.26.15-0.26.15a3,3,0,0,1-.39.2L35.6,74.4A3,3,0,0,0,36,74.2Z",
    fill: "#272626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,58.23l0.26-.15L9,57.93a1.1,1.1,0,0,1,1.24-.14l26.5,15.4c0.46,0.27.18,0.47-.24,0.71l-0.26.15L36,74.2a1.1,1.1,0,0,1-1.23.14L8.26,58.94C7.8,58.68,8.07,58.47,8.5,58.23Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.16,40.23L90.47,47,90.23,60.59l-0.12,0-0.08,0H89.71l-0.11,0-0.21-.1L89.11,47.62l0.2-7.45A0.89,0.89,0,0,0,90.16,40.23Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.82,24.77L63,26.58,62.89,45.13h0l-0.08-.06h0l0,0,0,0h0l0,0v0h0V44.86h0L62.58,24.5A0.41,0.41,0,0,0,62.82,24.77Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.32 40.17 89.39 60.53 62.89 45.13 62.82 24.77 89.32 40.17",
    fill: "#282828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.55,40l0.26-.15,0.26-.15a0.79,0.79,0,0,0,.48-0.44l0.07,20.36a0.79,0.79,0,0,1-.48.44l-0.26.15-0.26.15a3,3,0,0,1-.39.2L90.16,40.23A3,3,0,0,0,90.55,40Z",
    fill: "#272626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.07,24.06l0.26-.15,0.25-.15a1.1,1.1,0,0,1,1.24-.14L91.31,39c0.46,0.27.18,0.47-.24,0.71l-0.26.15L90.55,40a1.1,1.1,0,0,1-1.23.14l-26.5-15.4C62.36,24.51,62.64,24.3,63.07,24.06Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,22.77l1.42,0.83L67,24.43,90.06,37.85l1.43,0.83a16.26,16.26,0,0,1,1.7,1.11,1.43,1.43,0,0,1,.41,1.08v0.37a1.55,1.55,0,0,1-.68,1.36L90.1,44.22Q77.35,51.61,64.58,59L39.74,73.3l-0.68.39-2.82,1.63-1.42-.83L32,72.83,30.51,72l-1.44-.84-1.44-.84-8.68-5-8.65-5-1.43-.83-1.42-.83-0.14-.1,0,0a1.53,1.53,0,0,1-.45-0.79h0a3.68,3.68,0,0,1,0-.79s0-.09,0-0.13,0-.09,0-0.13,0-.08,0-0.12a0.84,0.84,0,0,1,0-.12l0-.11,0-.1,0-.09L7,56l0-.08,0-.07,0-.06,0,0,0,0,0,0,0,0,0,0,0,0,0.27-.16,2.64-1.52,2.82-1.63,2.83-1.63L18.74,49l2.83-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64L50,30.94l2.84-1.64,2.83-1.63L58.48,26Z",
    fill: "#575757",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,22.92h0l1.42,0.83L67,24.45l1.44,0.83,1.44,0.84L71.29,27l1.44,0.84,1.45,0.84,1.45,0.84,1.45,0.84,1.45,0.84L80,32l1.45,0.84,1.45,0.84,1.44,0.84,1.44,0.84,1.44,0.84L88.63,37l1.44,0.83,1.43,0.83,1.42,0.83-0.08,0-0.06,0,0,0h-0.3L64.12,22.93h0Z",
    fill: "#575757",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.27,53.88l2.82-1.63,2.83-1.63L18.75,49l2.83-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64,2.84-1.64L50,30.95l2.84-1.64,2.83-1.64L58.48,26l5.64-3.26h0v0a0.1,0.1,0,0,0,0,0v0L7.92,55.38a1,1,0,0,0-.47.13h0Z",
    fill: "#5e5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.61,41.25a1.55,1.55,0,0,1-.68,1.36Q66.33,58,39.75,73.31l-0.68.39-2.82,1.63s0-.36,0-1l54-31.28Z",
    fill: "#272626",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24,74.37c0,0.31,0,.63,0,0.94h0v0L8.88,59.43,7.45,58.6a1.58,1.58,0,0,1-.69-1.35h0Z",
    fill: "#212121",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.24 74 36.24 74.37 6.77 57.24 6.77 56.87 8.73 57.6 36.24 74",
    fill: "#3a3b3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.61 40.88 93.61 41.25 36.24 74.37 36.24 74 90 42.71 93.61 40.88",
    fill: "#282828",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,56l3.23,1.22L36.24,73v0.89s0,0.09,0,.13L6.77,56.87A1.74,1.74,0,0,1,7,56Z",
    fill: "#454545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.34,39.93a1.75,1.75,0,0,1,.27.95L36.24,74c0-.17,0-0.35,0-0.52V72.89L92,40.42Z",
    fill: "#3a3b3b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24,72.59V71.83l51.9-30.47,4.3-2,0.19,0,0.07,0,0.06,0,0.05,0,0.05,0,0.05,0,0.05,0,0.06,0,0.06,0.05,0.07,0.07,0.08,0.09,0.09,0.12-57.1,33V72.59Z",
    fill: "#575757",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.24,72.78V73L7,56a1.11,1.11,0,0,1,.93-0.6h0l3.23,1.36,25.08,15.1h0v0h0v0.88Z",
    fill: "#5e5f5f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.12,23.25L92.44,39.71,36.24,72.16,7.92,55.7Z",
    fill: "#454545",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.05,46.29l1.07-.57L49.18,34.59a0.08,0.08,0,0,0-.08,0L29,46.28A0.12,0.12,0,0,1,29.05,46.29Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.18 34.59 29.05 46.29 30.22 47.01 36.2 49.85 36.39 49.78 56.33 38.15 49.18 34.59",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.33,38.15L36.2,49.85S36.33,50,36.35,50l20.06-11.8Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.41,38.19L36.28,49.89h0a3.22,3.22,0,0,1,.21.29L56.61,38.34A1.39,1.39,0,0,0,56.41,38.19Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.61,38.34L36.49,50c0.07,0.14.15,0.43,0.24,0.57L56.87,38.79A0.78,0.78,0,0,0,56.61,38.34Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.87,38.79L36.75,50.49a0.92,0.92,0,0,1-.09.35l20.13-11.7A0.35,0.35,0,0,0,56.87,38.79Z",
    fill: "#e2d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.28,49.89l-0.08,0-7.15-3.56c-0.07,0-.12,0-0.12.09a0.29,0.29,0,0,0,.14.22l7,3.47a0.39,0.39,0,0,0,0,.1,0.81,0.81,0,0,0,.37.63c0.27,0.15.36,0,.36-0.23A0.83,0.83,0,0,0,36.28,49.89Z",
    fill: "#cdcccc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "56.86 44.16 51.34 47.33 56.58 50.28 62 47.13 56.86 44.16",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.78,47.26l-5,2.74-0.25.28a1.48,1.48,0,0,0,.77.42c1.82,0.26,3.8-1.95,5.5-3.09C63.43,47.22,62,47.1,61.78,47.26Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.43,47.31l5.43-3.15a0.14,0.14,0,0,0-.14,0L51.29,47.3A0.21,0.21,0,0,1,51.43,47.31Z",
    fill: "#e3dcdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.58,50.28l-5.15-3a0.12,0.12,0,0,0-.19.11,0.42,0.42,0,0,0,.19.33l5.15,3V50.28Z",
    fill: "#e2d9d9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M65,38.49L49.8,47.18l-2.87,1.71a0.6,0.6,0,0,0-.11.28l1.31-.63,1.53-.74,0.19-.11,15.26-8.63a1.22,1.22,0,0,0,.21-0.13l0.58-.4,2-1.37a0.37,0.37,0,0,0,.1-0.27Z",
    fill: "#e3dcdc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.89 28.34 65.39 33.12 65.37 38.63 67.98 36.89 68.5 26.62 65.89 28.34",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.89,28.34l2.61-1.72C68.4,23.07,68.15,19.54,68,16a0.71,0.71,0,0,0-.26-0.62L65,16.79a1.2,1.2,0,0,1,.42.94c0.05,1.79-.3,3.94-0.21,5.73S65.84,26.59,65.89,28.34Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,16.19V16a0.71,0.71,0,0,0-.26-0.62L65,16.79a1.19,1.19,0,0,1,.42.92Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "50.42 37.09 49.9 47.38 65.37 38.63 65.89 28.34 57.53 32.72 50.42 37.09",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.45 38.62 47.14 39.4 46.93 48.89 49.9 47.38 50.49 39.34 50.42 37.09 49.09 37.59 47.45 38.62",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.47,18.75q0-.49,0-1a1.1,1.1,0,0,0-.44-1L49.53,25.54a0.92,0.92,0,0,1,.38.54A4.15,4.15,0,0,1,50,27c0,2,.17,4.08.27,6,0.07,1.34.13,2.68,0.17,4l15.47-8.76C65.8,25.14,65.59,21.95,65.47,18.75Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.43,17.69A1,1,0,0,0,65,16.79L49.53,25.54a0.92,0.92,0,0,1,.38.54,2.45,2.45,0,0,1,.07.53Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.58,15.37L64.83,16.7l-0.16.08L49.29,25.49l-0.11.07c-0.87.6-1.76,1.2-2.62,1.81a0.21,0.21,0,0,1,.18,0l2.79-1.83L65,16.79l2.79-1.42A0.18,0.18,0,0,0,67.58,15.37Z",
    fill: "#fbfbfb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,26.39a1.67,1.67,0,0,0-.84-0.86l-2.79,1.83a0.78,0.78,0,0,1,.26.55c0.1,3.2.1,6.47,0.22,9.67,0,0.35.23,0.69,0.24,1l3-1.53c0-1.28.08-2.61,0.09-3.91C50.52,30.9,50.44,28.65,50.37,26.39Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,26.39a1.68,1.68,0,0,0-.84-0.85l-2.79,1.83a0.78,0.78,0,0,1,.26.55v0.41Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,27.92a0.65,0.65,0,0,0-.26-0.55c-0.12-.07-0.26,0-0.26.24q0.15,10.6-.06,21a0.63,0.63,0,0,0,.26.54c0.11,0.07.24,0,.26-0.26l0.52-10.27C47.35,35.09,47.1,31.46,47,27.92Z",
    fill: "#e3dcdc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M63.81,44.85L61,46.19,58.38,48a10.63,10.63,0,0,1,.17,1.47l3.3-1.6L64,46.32A10.76,10.76,0,0,0,63.81,44.85Z",
    fill: "#dfd6d5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,46.32l-5.43,3.15A2.37,2.37,0,0,1,58.07,51l5.43-3.15a0.85,0.85,0,0,0,.35-0.46A2.94,2.94,0,0,0,64,46.32Z",
    fill: "#dad1d0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.65,35.12l4-2.27a0.14,0.14,0,0,0-.14,0l-4,2.27A0.16,0.16,0,0,1,55.65,35.12Z",
    fill: "#e2d9d9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.73 35.96 57.76 38.24 58.09 46.08 58.38 48 63.81 44.85 61.73 35.96",
    fill: "#e3dcdc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.63,32.85l-4,2.27c0.33,0.2.64,0.43,0.95,0.64l4-2.27A7.37,7.37,0,0,0,59.63,32.85Z",
    fill: "#f7f4f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.57,33.49l-4,2.27a2.72,2.72,0,0,1,.87,1.32l4-2.27A2.72,2.72,0,0,0,60.57,33.49Z",
    fill: "#f2edec",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.44,34.81l-4,2.27a9.19,9.19,0,0,1,.29,1.16l4-2.27A9.23,9.23,0,0,0,61.44,34.81Z",
    fill: "#ece8e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.26,46.07l-0.5-7.83c-0.36-1.8-.67-2.27-2.11-3.12a0.12,0.12,0,0,0-.19.11,0.42,0.42,0,0,0,.19.34c1.3,0.77,1.43,1,1.73,2.57l0.51,8c0.05,0.81.11,1.58,0.21,2.39a2.74,2.74,0,0,1-.23,2,1.22,1.22,0,0,1-1.3-.26l-0.22.11,0.23,0.34a1.41,1.41,0,0,0,1.6.19c0.45-.4.42-1.42,0.29-2.38S58.31,46.9,58.26,46.07Z",
    fill: "#e2d9d9",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoContent);
export default __webpack_public_path__ + "static/media/no-content.3211bc64f993d57fff1b32da6c973dcc.svg";
export { ForwardRef as ReactComponent };